import useFetchObjects from "../../api/useFetchObjects";

const useFreeBookList = (page, searchQuery) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page);
  queryParams.append("page_size", "12");
  if (searchQuery) {
    queryParams.append("search", searchQuery);
  }

  return useFetchObjects(
    ["free-books", page, searchQuery],
    `books/free_books/?${queryParams.toString()}`,
    null,
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useFreeBookList;
